import { defineNuxtPlugin, useNuxtApp } from '#app'
import { useUserStore } from '@/store/user/user'

export default defineNuxtPlugin({
  name: 'initUserInfo',
  parallel: true,
  async setup() {
    const { $sentryCaptureException }: any = useNuxtApp()
    const { getInfo } = useUserStore()

    try {
      await getInfo({
        serverSide: false,
        isUserPages: false,
        urlPage: '',
      })
    } catch (error) {
      $sentryCaptureException('Не удалось получить данные пользователя', error)
    }
  },
})
